import app from 'app';
import { workPool } from '@wochitnpm/helpers';
/**
 *
 * @type {app.namespace.Controller.IntercomController}
 *
 *  - https://developers.intercom.com/v2.0/docs/intercom-javascript
 *  - http://blog.learningspaces.io/customizing-the-intercom-launcher/
 */
app.namespace.Controller.IntercomController = class {
  constructor(options) {
    this._options = Object.assign(
      {
        selector: '#IntercomWochitWidget',
        unreadSelector: '.intercom-unread-count',
        template: null,
        appendTo: document.body,
        intercomOptions: {},
      },
      options
    );

    this.promise = new _.ColdPromise();
  }

  start() {
    if (app.isEmbedded) {
      // intercom not relevant in embedded mode (product request)
      return;
    }

    workPool.once(
      {
        type: workPool.job.waitTillDefined.type,
        context: (jc) => jc.baseObj === window && jc.field === 'Intercom',
      },
      () => {
        this._createLauncher();
        this._boot();
        this._registerListeners();
      }
    );
    workPool.job.waitTillDefined.start({
      baseObj: window,
      field: 'Intercom',
      timeout: app.TIME.minute(5),
    });
  }

  showNewMessage(message = '') {
    return this.promise.then(() => {
      window.Intercom('showNewMessage', message);
    });
  }

  _createLauncher() {
    if (window.intercomSettings.hide_default_launcher) {
      const isId = this._options.selector.substr(0, 1) === '#';
      this.el = document.createElement('a');
      this.el.setAttribute(
        isId ? 'id' : 'class',
        this._options.selector.substr(1)
      );
      this.el.innerHTML =
        this._options.template ||
        `<div class="intercom-icon-close"></div>
                     <div class="intercom-icon-open"></div>
                     <span class="intercom-unread-count"></span>`.normalizeSpace();

      this._options.appendTo.appendChild(this.el);
    }
  }

  _boot() {
    // Initialize Intercom
    // app_id and custom_launcher_selector are booted from segment
    // hide_default_launcher is added in index on window.intercomSettings -
    // so it will remove the default launcher as fast as possible
    window.Intercom('boot', this._options.intercomOptions);

    if (window.intercomSettings.hide_default_launcher) {
      // Wait for Intercom to boot (max 30 seconds)
      // because Intercom api lacks a ready callback, we do this
      const timeout = setTimeout(() => {
        clearInterval(interval);
        this.promise.reject();
      }, 30000);

      const interval = setInterval(() => {
        if (window.Intercom.booted) {
          // Add class to show the launcher
          this.el.classList.add('intercom-booted');

          clearInterval(interval);
          clearTimeout(timeout);
          this.promise.resolve();
        }
      }, 100);
    }
  }

  _registerListeners() {
    // Register callbacks
    if (window.intercomSettings.hide_default_launcher) {
      const unreadCount = this.el.querySelector(this._options.unreadSelector);

      window.Intercom('onShow', () => this.el.classList.add('intercom-open'));

      window.Intercom('onHide', () =>
        this.el.classList.remove('intercom-open')
      );

      window.Intercom('onUnreadCountChange', (count) => {
        unreadCount.textContent = count;

        if (count) {
          unreadCount.classList.add('active');
        } else {
          unreadCount.classList.remove('active');
        }
      });
    }
  }
};

export default app.namespace.Controller.IntercomController;
